/* eslint-disable no-useless-escape */
import filter from 'lodash/filter';
import _uniqBy from 'lodash/uniqBy';
import _pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import compact from 'lodash/compact';
import { parse } from 'query-string';
import { initGuidedOptionFilter } from './actionCreators';
import { addRoomMeasure } from './measuresActions';
import { setSelectedCarpetPad } from './carpetPadActions';
import { updateSteps, confirmSteps, questionAnswered } from './stepsAction';
import { setStore } from './store';
import {
  isMultiSelectChoice,
  isMultiSelectOption,
  getSplitUrlQuery,
  getChoicePaths,
  updateRoomsPath,
  updateStepsPath,
  getSelectedPadFromConfigurator,
  updateCarpetPadPath,
  updateCarpetPath,
  updateOmsIdPath,
} from '../utils/pathUtils';
import { updateSelectedChoice } from '.';
import { getRoomsFromPIP } from '../utils/pipRooms';
import { roomsArraySelector } from '../selectors/roomMeasure';
import { pricingNodeSelector } from '../selectors/pricing';
import { selectSelectedSkuData } from '../selectors/skuDataSelectors';

export const UPDATE_PATH = 'UPDATE_PATH';
let dispatchedFromOmsIdFlag = false;
const getParamFromUrl = (key) => {
  const { search } = window.location;
  const paramsObj = parse(search);
  return paramsObj?.[key];
};

export const fromSavedDesign = () => {
  const currentUrl = decodeURIComponent(document.baseURI);
  const isRedirectFromSignIn = currentUrl.includes('signin?redirect');
  const itemId = getParamFromUrl('item');
  return !isRedirectFromSignIn && itemId;
};

export const updatePath = () => (dispatch, getState) => {
  const currentUrl = decodeURIComponent(document.baseURI);

  /*
  we have two work flows that are updating the url path ssku configurator and non-ssku (original configurator)
  original path params [store, rooms, steps, carpettype, multiChoice, carpet, pad, omsId]
  ssku path params [store, rooms, steps, carpet, pad, omsId ]
  */

  const {
    configurator: { options, choices },
    config: { isCanonicalUrlSelfReferenced },
    store: { storeNumber },
    mandiMore: { omsIdFromUrl }
  } = getState();

  const previousParams = parse(currentUrl.split('?')[1]);

  const measuresState = roomsArraySelector(getState());
  const { steps } = getState();
  const selectedCarpetPad = getSelectedPadFromConfigurator(options, choices);
  const { choicesWithPrices } = pricingNodeSelector(getState());
  const { sku: omsId } = selectSelectedSkuData(getState());
  const omsIdParam = updateOmsIdPath(choicesWithPrices, omsId);
  let currentParams = {};

  const checkForRooms = () => {
    const hasLocalStorageMeasures = !isEmpty(getRoomsFromPIP());
    if (!hasLocalStorageMeasures) {
      return '';
    }
    return updateRoomsPath(measuresState) || previousParams.rooms;
  };
  // bypass update path flow if coming from saved design
  if (fromSavedDesign()) {
    currentParams = { ...previousParams, omsId: omsIdParam || previousParams.omsId };
  } else {
    currentParams = {
      ...previousParams, // this is a hack to keep the debug params for nucleus
      rooms: checkForRooms(),
      steps: updateStepsPath(steps) || previousParams.steps,
      pad: updateCarpetPadPath(selectedCarpetPad) || previousParams.pad,
      carpet: updateCarpetPath(choicesWithPrices) || previousParams.carpet,
      store: `Store-${storeNumber}` || previousParams.store,
      carpettype: '' || previousParams.carpettype,
      multiChoice: '' || previousParams.multiChoice,
      omsId: omsIdParam || previousParams.omsId
    };
  }

  const choicePaths = getChoicePaths(options, choices);
  choicePaths.forEach((path) => {
    const [key, pathVal] = path.split('=');
    const standardOptions = ['rooms', 'steps', 'pad', 'carpet', 'omsId'];
    if (!standardOptions.includes(key) && pathVal) {
      // this is an override for fallback configurator functionality
      if (key === 'carpettypecolorfamily') {
        currentParams.carpet = pathVal;
      } else {
        currentParams[key] = pathVal;
      }
    }
  });

  const combinedUrlPaths = compact(Object.entries(currentParams).map(([key, val]) => {
    if (key === 'isEdit') { return 'isEdit'; } // isEdit has no value it's either present or not
    if (val) { return `${key}=${val}`; }
    return null;
  })).filter((x) => x.length > 0)
    .sort()
    .join('&')
    .trim()
    .replace(/([^:]\&)\&+/g, '$1');
  window.history.replaceState(null, document.title, `?${combinedUrlPaths}`);

  let splitUrlQuery = getSplitUrlQuery(window.location.search);
  const combinedArray = [...choicePaths, ...splitUrlQuery];
  const allQueryParams = _uniqBy(combinedArray, (param) => param.split('=')[0].toLowerCase());

  // If from OmsId, then invoke action once ???
  if (omsIdFromUrl && !dispatchedFromOmsIdFlag) {
    const findQueryParams = ['carpettype', 'multiChoice', 'pad', 'carpet', 'store'];
    const onlyQueryNames = allQueryParams.map((x) => x.split('=')[0]);
    const foundAllQueryParams = findQueryParams.every((i) => onlyQueryNames.includes(i));

    if (foundAllQueryParams) {
      try {
        const selectedCarpet = getParamFromUrl('carpet');
        const selectedCarpetSwatchArray = selectedCarpet.split('_');
        const selectedCarpetSwatchId = selectedCarpetSwatchArray[selectedCarpetSwatchArray.length - 1];
        const selectedCarpetSwatchValue = selectedCarpetSwatchArray[0];
        if (omsIdFromUrl === +selectedCarpetSwatchId) {
          dispatch({
            type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS',
            choiceId: +selectedCarpetSwatchId,
            choiceValue: selectedCarpetSwatchValue,
          });
          dispatch(updateSelectedChoice({ id: +selectedCarpetSwatchId }));
          dispatchedFromOmsIdFlag = true;
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(`${err.message}`);
      }
    }
  }
};
export const preloadStore = (persistedStore) => (dispatch) => {
  if (!isEmpty(persistedStore)) {
    const {
      address, distance, id: storeId, name, phone
    } = persistedStore;
    if (Number.isFinite(storeId)) {
      const store = {
        isStoreEnabled: true,
        storeNumber: storeId,
        zipcode: address.zipcode,
        storeInfo: {
          storeId,
          name,
          distance,
          phone,
          address,
        }
      };
      dispatch(setStore({ persistedStore: store }));
    }
  }
};

export const preloadRooms = (roomsFromPath, isFromEdit) => (dispatch) => {
  const localStorageMeasures = getRoomsFromPIP();
  if (!isFromEdit && !isEmpty(localStorageMeasures)) {
    localStorageMeasures.forEach((lsmeasure) => dispatch(addRoomMeasure(lsmeasure)));
  } else if (!isEmpty(roomsFromPath)) {
    roomsFromPath.split(',').forEach((rm) => {
      if (rm) {
        const [room, length, width, sqft] = rm?.split('-');
        const roomMeasure = {
          room: room.replace('%20', ' '),
          length: parseFloat(length),
          width: parseFloat(width),
          sqFt: parseFloat(sqft)
        };
        dispatch(addRoomMeasure(roomMeasure));
      }
    });
  }
  // this probably should not be hard coded but is existing
  dispatch({ type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS', choiceId: 60709, choiceValue: 'roommeasurements' });
};

export const preloadSteps = (hasSteps) => (dispatch) => {
  if (hasSteps) {
    const [stepsAdded, stepCount, sqFtArea] = hasSteps?.split('-');
    if (stepsAdded === 'Yes') {
      dispatch(updateSteps(parseFloat(stepCount), 0, parseFloat(sqFtArea)));
      dispatch(confirmSteps(true));
    }
    dispatch(questionAnswered(true));
  }
};

export const preloadCarpetPad = (selectedCarpetPad) => (dispatch, getState) => {
  if (selectedCarpetPad) {
    const { configurator: { choices } } = getState();
    const carpetPad = selectedCarpetPad.split('_');
    const carpetPadChoiceId = carpetPad.slice(-1);
    if (carpetPadChoiceId) {
      const selectedChoice = choices[carpetPadChoiceId];
      if (selectedChoice) {
        const unselectedChoices = _pickBy(choices,
          (choice) => choice.optionId === selectedChoice.optionId && choice.id !== selectedChoice.id);
        const unselectedChoiceIds = Object.keys(unselectedChoices).map((id) => +id);
        dispatch({
          type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS',
          choiceId: selectedChoice.id,
          choiceValue: selectedChoice.shortLabel,
          siblingIds: unselectedChoiceIds,
          settingDefaultsOnChange: false
        });
        dispatch(setSelectedCarpetPad(selectedChoice));
      }
    }
  }
};

export const preloadCarpetSwatch = (isRefresh = false) => (dispatch) => {
  const queryParams = new URLSearchParams(window.location.search);
  const selectedOmsId = queryParams.get('omsId');
  const selectedCarpetSwatch = queryParams.get('carpet');
  if (!selectedOmsId && selectedCarpetSwatch) {
    const [selectedCarpetSwatchValue, selectedCarpetSwatchId] = selectedCarpetSwatch.split('_');
    if (selectedCarpetSwatchId) {
      if (isRefresh) {
        dispatch({
          type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS',
          choiceId: +selectedCarpetSwatchId,
          choiceValue: selectedCarpetSwatchValue,
        });
      }
      dispatch(updateSelectedChoice({ id: +selectedCarpetSwatchId }));
    }
  }
};

export const preloadColorFamilies = (hasMultiChoice) => (dispatch, getState) => {
  if (hasMultiChoice) {
    const { configurator: { choices, options } } = getState();

    const multiSelectOptionId = options.allIds.find((id) => isMultiSelectOption(options, id));
    const multiSelectChoiceId = options[multiSelectOptionId].choices.find((id) => isMultiSelectChoice(choices, id));

    let colorChoices = hasMultiChoice;
    if (colorChoices.match(/^\d/) && colorChoices.indexOf('_') >= 0) {
      colorChoices = colorChoices.substring(colorChoices.indexOf('_') + 1);
    }
    const colorFamilies = colorChoices.split(',');
    const multiSelectChoiceIds = options[multiSelectOptionId].choices;
    // eslint-disable-next-line array-callback-return
    multiSelectChoiceIds.map((id) => {
      if (colorFamilies.includes(choices[id].value)) {
        choices[id] = { ...choices[id], isMultiSelected: true };
      }
    });
    const choiceValues = colorFamilies.join('|');
    choices[multiSelectChoiceId].value = choiceValues;
    let choiceValuesWithoutId = choiceValues;
    if (choiceValuesWithoutId.indexOf('_') >= 0) {
      choiceValuesWithoutId = choiceValues.substring(choiceValues.indexOf('_') + 1);
    }
    dispatch(initGuidedOptionFilter({ type: 'colorFamily', colorfamily: choiceValuesWithoutId })
    );
    dispatch({
      type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS',
      choiceId: +multiSelectChoiceId,
      choiceValue: choiceValuesWithoutId,
    });
  }
};

export const preloadCarpetType = (selectedCarpetType) => (dispatch, getState) => {
  const { configurator: { choices, options } } = getState();
  if (selectedCarpetType) {
    const [carpetType, carpetTypeChoiceId] = selectedCarpetType.split('_');
    if (carpetType && carpetTypeChoiceId) {
      const selectedChoice = choices[carpetTypeChoiceId];
      if (selectedChoice && !selectedChoice.isDisabled) {
        const allCarpetTypeOptions = filter(options, (op) => op.tags?.includes('filter:carpettype'));
        const choiceIds = Array.prototype.concat.apply([], allCarpetTypeOptions.map((option) => option.choices));
        const filteredChoiceIds = choiceIds.filter((id) => id !== selectedChoice.id);
        dispatch(initGuidedOptionFilter({ type: 'carpetType', carpettype: carpetType }));
        dispatch({
          type: 'GCC_CONFIGURATOR/CHOICE_CHANGED_SUCCESS',
          choiceId: selectedChoice.id,
          choiceValue: selectedChoice.shortLabel,
          siblingIds: filteredChoiceIds,
          settingDefaultsOnChange: false
        });
      }
    }
  }
};